import { render } from "./Skills.vue?vue&type=template&id=52ab495a&scoped=true&ts=true"
import script from "./Skills.vue?vue&type=script&lang=ts"
export * from "./Skills.vue?vue&type=script&lang=ts"

import "./Skills.vue?vue&type=style&index=0&id=52ab495a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ab495a"]])

export default __exports__